import Context from 'managers/Context';
import { getMarketingCampaignStatusFilterOptions } from 'containers/campaigns/marketing/utils/marketingCampaignStatus';
import { buildMarketingCampaignListQueryParams } from 'containers/campaigns/marketing/utils/marketingCampaignListQueryParams';
import { FuzzyMap } from 'utils/fuzzy';
import { getLiteral } from 'utils/getLiteral';

export default class CampaignsMarketingManager {
    getNewApiListParams = (filters) => buildMarketingCampaignListQueryParams(filters);

    getNewApiCountParams = (filters) => buildMarketingCampaignListQueryParams(filters);

    getFilterSchema = () => {
        const state = Context.store.getState();
        const currentUser = `${state.config.userData.nombre} ${state.config.userData.apellidos}`;

        const userFuzzy = {
            ...FuzzyMap.viewusuariosfullname,
            defaultSearch: currentUser,
        };

        return [
            {
                id: 'status',
                dataType: 'singleValueList',
                description: getLiteral('label_status'),
                fieldConfiguration: 'status',
                generateOptions: getMarketingCampaignStatusFilterOptions,
                inputAttrs: {
                    isMulti: true,
                },
                hint: getLiteral('action_select'),
            },
            {
                id: 'updatedUser',
                dataType: 'singleValueList',
                description: getLiteral('label_user_last_modification'),
                fieldConfiguration: 'updatedUser',
                inputAttrs: { ...userFuzzy },
                hint: getLiteral('action_searchowner'),
            },
            {
                id: 'createdUser',
                dataType: 'singleValueList',
                description: getLiteral('label_campaigns_list_created_by'),
                fieldConfiguration: 'createdUser',
                inputAttrs: { ...userFuzzy },
                hint: getLiteral('action_searchowner'),
            },
            {
                id: 'dateCreation',
                description: getLiteral('label_created_date'),
                dataType: 'date',
                fieldConfiguration: 'dateCreation',
                locators: {
                    first: 'campaigns-marketing-filter__creation-date-start',
                    last: 'campaigns-marketing-filter__creation-date-end',
                },
            },
            {
                id: 'dateModification',
                description: getLiteral('label_modified'),
                dataType: 'date',
                fieldConfiguration: 'dateModification',
                locators: {
                    first: 'campaigns-marketing-filter__modified-date-start',
                    last: 'campaigns-marketing-filter__modified-date-end',
                },
            },
            {
                id: 'dateLaunch',
                dataType: 'date',
                description: getLiteral('label_sent_date'),
                fieldConfiguration: 'dateLaunch',
                locators: {
                    first: 'campaigns-marketing-filter__send-date-start',
                    last: 'campaigns-marketing-filter__send-date-end',
                },
            },
        ];
    };
}
